angular
  .module("AccountingBoxApp")
  .controller("BankAccountsCtrl", function(
    $scope,
    $rootScope,
    $location,
    $filter,
    $stateParams,
    $state,
    $window,
    // ngTableParams,
    BankAccount,
    FileUploader,
    LoopBackAuth,
  ) {
    var vm = this;
    $scope.order = {
      by: "bankAccountNumber",
      reverse: false,
      filter: ""
    };
    //     $scope.removeModal = false;


    vm.lastUpdateText = function(account) {
      // if (account.status === 'failed') {
      //   return 'Ophalen mislukt';
      // }
      return account.bankBalanceDate;
    };
    vm.bankAccountClickedDownload = {};
    vm.editBankAccount = function(account) {
      $scope.bankAccount = account;
      $scope.$broadcast("editBankAccount");

      $("#bankAccountModal").modal("show");
    };
    vm.newBankAccount = function() {
      $scope.$broadcast("newBankAccount");
      //$state.go('app.company.bank.new');
      $("#bankAccountModal").modal("show");
    };
    vm.downloadBankTransactions = function(account) {
      /* setTimeout(function() {
            }, 300);*/
      vm.bankAccountClickedDownload = account;

      $window.open(vm.downloadLink(account), "_blank");
    };

    vm.viewTransactions = function(bankAccount) {
      $state.go("app.company.bank.transactions", {
        id: bankAccount.id,
        bankAccount: bankAccount
      });
    };
    $scope.$on("closeBankAccount", function(e, bankAccount) {
      $("#bankAccountModal").modal("hide");
      /*   setTimeout(function() {
                vm.initialize(true,vendor.id);
              }, 500);*/
    });

    $scope.$on("bankAccountSaved", function(e, bankAccount) {
      vm.loadBankAccounts();
      setTimeout(function() {
        vm.loadBankAccounts();
      }, 10000);
      //  purchase.vendor = vendor;
    });

    $scope.$on("removeBankAccountConfirmation", function(e, bankAccount) {
      $scope.removeBankAccount = bankAccount;
      $("#bankAccountModal").modal("hide");

      //console.log('removebankaccount:', $scope.removeBankAccount);
      $("#removeModal").appendTo(".app-content");
      $("#removeModal").modal("show");
      //  purchase.vendor = vendor;
    });

    vm.removeBankAccount = function(bankAccount) {
      $("#removeModal").modal("hide");
      BankAccount.deleteById({
        id: bankAccount.id
      }).$promise.then(function() {
        vm.loadBankAccounts();
      });
    };

    vm.loadBankAccounts = function() {
      vm.loading = true;
      BankAccount.find(function(bankaccounts) {
        vm.bankAccounts = bankaccounts;
        vm.loading = false;
      });
    };

    vm.loadBankAccounts();

    vm.downloadLink = function(bankAccount) {
      var link = "";
      var bN = bankAccount.bankName;
      var t = bankAccount.bankType;
      if (bN === "SNS Bank" && t === "private") {
        link = "https://www.snsbank.nl/mijnsns/secure/login.html";
      }
      if (bN === "SNS Bank" && t === "business") {
        link = "https://www.snsbank.nl/mijnsns/secure/loginzakelijk.html";
      }
      if (bN === "Rabobank") {
        link = "https://bankieren.rabobank.nl/klanten/";
      }
      if (bN === "ASN Bank" && t === "private") {
        link =
          "https://www.asnbank.nl/onlinebankieren/secure/loginparticulier.html";
      }
      if (bN === "ASN Bank" && t === "business") {
        link =
          "https://www.asnbank.nl/onlinebankieren/secure/loginzakelijk.html";
      }
      if (bN === "RegioBank" && t === "private") {
        link = "https://www.regiobank.nl/internetbankieren/secure/login.html";
      }
      if (bN === "RegioBank" && t === "business") {
        link =
          "https://www.regiobank.nl/internetbankieren/secure/loginzakelijk.html";
      }
      if (bN === "Knab") {
        link = "https://persoonlijk.knab.nl/account/inloggen";
      }
      if (bN === "Triodos Bank") {
        link = "https://bankieren.triodos.nl/ib-seam/login.seam";
      }
      if (bN === "Van Lanschot") {
        link = "https://www.vanlanschot.com/ebanking/myportal";
      }
      if (bN === "Van Lanschot") {
        link = "https://www.vanlanschot.com/ebanking/myportal";
      }
      if (bN === "Mollie") {
        link = "https://www.mollie.com/nl/#login";
      }
      if (bN === "Bunq") {
        link = "https://www.bunq.com/nl/";
      }
      if (bN === "Moneyou") {
        link =
          "https://secure.moneyou.nl/cwsoft/policyenforcer/pages/loginB2C.jsf";
      }

      // if (LoopBackAuth.currentUserData.isBookkeeper) {
      if (bN === "ING" && t === "business") {
        link =
          "https://mijnzakelijk.ing.nl/internetbankieren/SesamLoginServlet";
      }
      if (bN === "ING" && t === "private") {
        link = "https://mijn.ing.nl/internetbankieren/SesamLoginServlet";
      }
      if (bN === "ABN AMRO" && t === "business") {
        link = "https://www.abnamro.nl/portalserver/nl/zakelijk/index.html";
      }
      if (bN === "ABN AMRO" && t === "private") {
        link = "https://www.abnamro.nl/portalserver/nl/prive/index.html";
      }
      // }

      return link;
    };

    var url = function(bankAccount) {
      var u =
        API_ENDPOINT +
        "/BankAccounts/" +
        bankAccount.id +
        "/uploadBankStatement";

      if (
        LoopBackAuth.currentUserData.isBookkeeper &&
        $rootScope.currentCompany
      ) {
        u = u + "?currentCompanyId=" + $rootScope.currentCompany.id;
      }
      return u;
    };

    vm.uploader = function(bankAccount) {
      var uploader = ($scope.uploader = new FileUploader({
        url: url(bankAccount),
        headers: {
          Authorization: LoopBackAuth.accessTokenId
        }
      }));
      uploader.onAfterAddingAll = function(addedFileItems) {
        uploader.uploadAll();
        console.info("onAfterAddingAll", addedFileItems);
      };

      uploader.onSuccessItem = function(fileItem, response, status, headers) {
        console.info("onSuccessItem", fileItem, response, status, headers);
        console.log("sucuess item upload", fileItem);
        vm.loadBankAccounts();
        // $scope.$broadcast('uploadAdded', fileItem);
      };
      uploader.onErrorItem = function(item, response, status, headers) {
        console.log("response:", response);
        window.swal("Mislukt", response.error.message, "error");
      };
      return uploader;
    };
  });
